export default function TestimonialSection() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-4xl font-serif text-center text-[#1a2b4a] mb-16" style={{ fontFamily: 'Merriweather, serif' }}>
          Trusted by Legal Professionals Nationwide
        </h2>

        <div className="bg-white rounded-2xl p-12 shadow-lg">
          <div className="flex items-start gap-6 mb-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#1a2b4a] rounded-full">
              <i className="ri-star-fill text-yellow-400 text-sm"></i>
              <span className="text-white text-sm font-medium">4.9/5 Rating</span>
            </div>
          </div>

          <blockquote className="text-2xl font-serif text-gray-800 mb-8 leading-relaxed" style={{ fontFamily: 'Merriweather, serif' }}>
            "Their client portal has revolutionized how we manage process serving for our firm. Real-time tracking and instant document access saves us hours every week. The small claims document preparation service is incredibly thorough and accurate."
          </blockquote>

          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#1a2b4a] to-[#ff6b35] flex items-center justify-center">
              <span className="text-white text-xl font-bold">SM</span>
            </div>
            <div>
              <div className="text-lg font-bold text-[#1a2b4a]">Sarah Mitchell, Esq.</div>
              <div className="text-sm text-gray-600">Mitchell & Associates Law Firm</div>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-8">
          <button className="w-12 h-12 flex items-center justify-center border-2 border-gray-300 rounded-lg hover:border-[#1a2b4a] transition-colors cursor-pointer">
            <i className="ri-arrow-left-line text-gray-600"></i>
          </button>
          <button className="w-12 h-12 flex items-center justify-center bg-[#1a2b4a] rounded-lg hover:bg-[#2a3b5a] transition-colors cursor-pointer">
            <i className="ri-arrow-right-line text-white"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
